import { render, staticRenderFns } from "./SiteDetails.vue?vue&type=template&id=8f16f97e&scoped=true"
import script from "./SiteDetails.vue?vue&type=script&lang=js"
export * from "./SiteDetails.vue?vue&type=script&lang=js"
import style0 from "./SiteDetails.vue?vue&type=style&index=0&id=8f16f97e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f16f97e",
  null
  
)

export default component.exports